import React from 'react';
import { Button, Typography, makeStyles } from '@material-ui/core';
import { images } from 'assets/images';
import { COLOR, isDev, COLOR_CONTRAST_RATIO } from 'config/constants';
import { useIntl } from 'react-intl';
import { getColorContrastRatio } from 'utils';

interface Props {
  broker_portal_infos?: any;
  reason?: string;
}

function NotFound(props: Props) {
  const intl = useIntl();
  const { broker_portal_infos, reason } = props;

  const useStyles = makeStyles({
    bodyContent: {
      padding: '40px 20px',
      display: 'flex',
      height: 'calc(100vh - 400px)',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    },
    contentTitle: {
      fontSize: 50,
      fontFamily: 'FordAntenna-Bold',
    },
    contentSubtitle: {
      fontSize: 20,
      marginTop: 10,
      fontFamily: 'FordAntenna-Medium',
    },
    contentDescription: {
      marginBottom: 20,
    },
    image: {
      width: 'auto',
      height: 250,
      marginBottom: 20,
    },
  });

  const classes = useStyles({});

  const secondary_color = broker_portal_infos?.template_style?.secondary_color || COLOR.BLACK;
  const secondary_color_contrast_ratio = getColorContrastRatio(secondary_color, COLOR.WHITE);
  const secondary_bg_text_color =
    secondary_color_contrast_ratio > COLOR_CONTRAST_RATIO ? COLOR.WHITE : COLOR.BLACK;

  const fmtNotFound = intl.formatMessage({ id: 'notFound.title' });
  const fmtNotExists = intl.formatMessage({ id: 'notFound.subtitle' });
  const fmtBack = intl.formatMessage({ id: 'notFound.back' });

  const onClickButton = () => {
    if (isDev()) {
      window.location.href = `/dev-broker-portal?domain_name=${broker_portal_infos.domain_name}`;
    } else if (broker_portal_infos.custom_domain_name) {
      const customDomain = broker_portal_infos.custom_domain_name.startsWith('http')
        ? broker_portal_infos.custom_domain_name
        : `https://${broker_portal_infos.custom_domain_name}`;
      window.location.href = customDomain;
    } else {
      window.location.href = `https://${broker_portal_infos.domain_name}`;
    }
  };

  return (
    <div className={classes.bodyContent}>
      <img className={classes.image} src={images.notFound} alt='Not Found' />
      <Typography className={classes.contentSubtitle}>{fmtNotFound}</Typography>
      <Typography className={classes.contentDescription}>{reason || fmtNotExists}</Typography>
      {broker_portal_infos ? (
        <Button
          onClick={onClickButton}
          style={{ backgroundColor: secondary_color, color: secondary_bg_text_color }}
        >
          {fmtBack}
        </Button>
      ) : null}
    </div>
  );
}

export default NotFound;
